export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '直推下级认证奖励配置';